import { isServer as e } from "@qwik.dev/core/build";
var t = (e) => {
	let t;
	if (typeof MessageChannel < "u") {
		let n = new MessageChannel(), r = !0;
		n.port1.onmessage = () => e(), t = () => {
			r && n.port2.postMessage(null);
		}, t.$destroy$ = () => {
			r && (r = !1, n.port1.onmessage = null, n.port1.close(), n.port2.close());
		};
	} else t = () => setTimeout(e);
	return t;
};
globalThis.qDev, globalThis.qInspector, globalThis.qDynamicPlatform, globalThis.qRuntimeQrl;
var n = function(e) {
	return e.PAUSED = "paused", e.RESUMED = "resumed", e.HTML = "html", e.TEXT = "text", e;
}({});
"" + n.HTML + n.TEXT;
var r = !e && typeof document < "u", i = r ? document : void 0, a = {
	$DEBUG$: !1,
	$maxIdlePreloads$: 25
}, o = r && i.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload", s = /\.[mc]?js$/, c = new Map(), l, u, d = 0, f = [], p = t(b), m = t(C), h = !1, g = !1, _ = !1, v = [], y = () => {
	u &&= (f.sort((e, t) => e.$inverseProbability$ - t.$inverseProbability$), !1);
};
function b() {
	if (h = !1, !f.length) return;
	y();
	let e = performance.now() + 10, t = !1;
	for (; f.length;) {
		let n = f[0];
		if (1 - n.$inverseProbability$ >= .99 || d < a.$maxIdlePreloads$) {
			if (f.shift(), w(n), performance.now() >= e) {
				t = !0;
				break;
			}
		} else break;
	}
	t && f.length && !h && (h = !0, p());
}
var x = (e, t, n) => {
	v.unshift({
		$bundle$: e,
		$inverseProbability$: t,
		$seen$: n
	});
}, S = () => {
	let e = v[v.length - 1], t = e.$bundle$;
	if (e.$deps$) {
		let n = e.$index$;
		if (n >= e.$deps$.length) return v.pop(), !1;
		let r = e.$deps$[n];
		e.$index$ = n + 1;
		let i = M(r.$name$);
		if (i.$inverseProbability$ === 0) return !0;
		let a = 1 - t.$inverseProbability$, o;
		if (a === 1 || a >= .99) o = Math.min(.01, 1 - r.$importProbability$);
		else {
			let e = (1 - r.$importProbability$ * a) / r.$factor$;
			o = Math.max(.02, i.$inverseProbability$ * e), r.$factor$ = e;
		}
		return v.push({
			$bundle$: i,
			$inverseProbability$: o,
			$seen$: e.$seen$
		}), !0;
	}
	if (e.$seen$?.has(t)) return v.pop(), !1;
	let n = t.$inverseProbability$;
	if (t.$inverseProbability$ = e.$inverseProbability$, n - t.$inverseProbability$ < .01) return v.pop(), !1;
	if (O != null && t.$state$ < 2 && (t.$state$ === 0 && (t.$state$ = 1, f.push(t)), u = !0), t.$deps$?.length) {
		let n = e.$seen$ || new Set();
		return n.add(t), e.$seen$ = n, e.$deps$ = t.$deps$, e.$index$ = 0, !1;
	}
	return v.pop(), !1;
};
function C() {
	if (_ || !v.length) return;
	g = !1, _ = !0;
	let e = r ? performance.now() + 10 : 0, t = !1;
	for (; v.length;) {
		t = !0;
		let n = S();
		if (r && n && performance.now() >= e) {
			g || (g = !0, m());
			break;
		}
	}
	_ = !1, t && r && p();
}
var w = (e) => {
	if (e.$state$ >= 2) return;
	d++;
	let t = performance.now();
	e.$waitedMs$ = t - e.$createdTs$, e.$state$ = 2;
	let n = i.createElement("link");
	n.href = new URL(`${O}${e.$name$}`, i.baseURI).toString(), n.rel = o, n.as = "script", n.onload = n.onerror = () => {
		d--, e.$loadedMs$ = performance.now() - t, e.$state$ = 4, n.remove(), p();
	}, i.head.appendChild(n);
}, T = (e, t, n) => {
	x(e, t, n), r ? m() : C();
}, E = (e, t) => {
	let n = M(e);
	n && x(n, t);
}, D = (e, t) => {
	if (!e?.length) return;
	let n = t ? 1 - t : .4;
	if (Array.isArray(e)) for (let t = e.length - 1; t >= 0; t--) {
		let r = e[t];
		E(r, n);
	}
	else E(e, n);
	r ? m() : C();
};
r && document.addEventListener("qsymbol", (e) => {
	let { symbol: t, href: n } = e.detail;
	n && D(t.slice(t.lastIndexOf("_") + 1), 1);
});
var O, k, A = (e, t) => ({
	$name$: e,
	$state$: s.test(e) ? 0 : 3,
	$deps$: l ? t?.map((e) => ({
		...e,
		$factor$: 1
	})) : t,
	$inverseProbability$: 1,
	$createdTs$: performance.now(),
	$waitedMs$: 0,
	$loadedMs$: 0
}), j = (e) => {
	let t = new Map(), n = 0;
	for (; n < e.length;) {
		let r = e[n++], i = [], a, o = 1;
		for (; a = e[n], typeof a == "number";) a < 0 ? o = -a / 10 : i.push({
			$name$: e[a],
			$importProbability$: o,
			$factor$: 1
		}), n++;
		t.set(r, i);
	}
	return t;
}, M = (e) => {
	let t = c.get(e);
	if (!t) {
		let n;
		if (k) {
			if (n = k.get(e), !n) return;
			n.length || (n = void 0);
		}
		t = A(e, n), c.set(e, t);
	}
	return t;
}, N = (e, n, i) => {
	i && "P" in i && (a.$maxIdlePreloads$ = i.P), !(!r || e == null) && (O = e, n && n.then((e) => e.text()).then((e) => {
		k = j(JSON.parse(e));
		let n = [];
		for (let [e, t] of k.entries()) {
			let r = M(e);
			r.$deps$ = t, r.$inverseProbability$ < 1 && (n.push([r, r.$inverseProbability$]), r.$inverseProbability$ = 1);
		}
		if (!n.length) {
			p();
			return;
		}
		let r = 0, i = t(() => {
			let e = performance.now() + 10;
			for (; r < n.length;) {
				let [t, a] = n[r];
				if (r++, T(t, a), r < n.length && performance.now() >= e) {
					i();
					return;
				}
			}
			p();
		});
		i();
	}).catch(console.warn));
};
export { j as g, N as l, D as p };
